module.exports = __webpack_public_path__ + "img/imagen.1ae067f4.jpg";